import { combineReducers } from 'redux';
import createNamedWrapperReducer from 'src/reducers/createNamedWrapperReducer';
import { itemReducer } from 'src/reducers/common';
import listReducer from '../common/listReducer';
import axios from 'axios';
import * as Urls from 'src/constants/EndpointUrls';
import { redirectTo } from 'src/utils/Http';
import { setGlobalErrors, setGlobalSuccesses } from 'src/reducers/global';
// import { DESK_SSO_RATE_FORM } from 'src/constants/FormNames';
import { serializeHttpGetParams } from 'src/utils/Http';
import { setItem } from 'src/reducers/common/itemReducer';

export const REDUCER_NAME = 'deskSsoRates';

export const updateDeskSsoRate = data => async dispatch => {
  try {
    await axios.put(Urls.DESK_SSO_SETTINGS, data);
    dispatch(setGlobalSuccesses('Desk sso rate is updated.'));
    redirectTo(Urls.DESK_SSO_SETTINGS);
  } catch (e) {
    dispatch(setGlobalErrors(e.message));
  }
};

export const searchDeskSso = (year, month, rateType, employeeType) => async dispatch => {
  try {
    const params = { year, month, rateType, employeeType };

    const response = await axios.get(`${Urls.DESK_SSO_SETTINGS_SEARCH}?${serializeHttpGetParams(params)}`);
    dispatch(setItem(REDUCER_NAME, response.data.payload));
  } catch (e) {
    dispatch(setGlobalErrors(e.message));
  }
};

export default combineReducers({
  list: createNamedWrapperReducer(listReducer, REDUCER_NAME),
  item: createNamedWrapperReducer(itemReducer, REDUCER_NAME)
});